const range = (start: number, stop: number) => {
  if (start > stop)
    throw new Error('Start parameter must be less than stop parameter.');

  return Array.from({ length: stop - start }, (_, index) => start + index);
};

export { range };
